import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import Casino from "./pages/Casino";
import Sports from "./pages/Sports";
import MatchDetail from "./pages/MatchDetail";
import MyBets from "./pages/MyBets";
import CasinoBets from "./pages/CasinoBets";
import LiveCasino from "./pages/LiveCasino";
import Affiliate from "./pages/Affiliate";
import Wallet from "./pages/Wallet";
import UpiReturn from "./pages/UpiReturn";
import GameHistory from "./pages/GameHistory";
import Admin from "./pages/Admin";
import ChotaRoulette from "./pages/ChotaRoulette";
import MiniRoulette from "./pages/MiniRoulette";
import ProRoulette from "./pages/ProRoulette";
import LuckyDice from "./pages/LuckyDice";
import GemMiner from "./pages/GemMiner";
import HiLoRush from "./pages/HiLoRush";
import Plinko from "./pages/Plinko";
import Tower from "./pages/Tower";
import Limbo from "./pages/Limbo";
import CoinFlip from "./pages/CoinFlip";
import GamesBar from "./components/GamesBar";
import BottomNav from "./components/BottomNav";
import WelcomeBonusModal from "./components/WelcomeBonusModal";

// 200ms fade/slide on every route change (CSS-only; disabled under prefers-reduced-motion).
function PageFade({ children }) {
  const { pathname } = useLocation();
  return <main key={pathname} className="bbw-page min-h-[70vh] pb-20 lg:pb-0">{children}</main>;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Navbar />
          <PageFade>
            <Routes>
              <Route path="/" element={<Casino />} />
              <Route path="/sports" element={<Sports />} />
              <Route path="/match/:id" element={<MatchDetail />} />
              <Route path="/my-bets" element={<MyBets />} />
              <Route path="/slot-bets" element={<CasinoBets category="slot" />} />
              <Route path="/live-casino-bets" element={<CasinoBets category="live" />} />
              <Route path="/live-casino" element={<LiveCasino />} />
              <Route path="/affiliate" element={<Affiliate />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/upi-return" element={<UpiReturn />} />
              <Route path="/game-history" element={<GameHistory />} />
              <Route path="/games/roulette" element={<ChotaRoulette />} />
              <Route path="/games/mini-roulette" element={<MiniRoulette />} />
              <Route path="/games/pro-roulette" element={<ProRoulette />} />
              <Route path="/games/dice" element={<LuckyDice />} />
              <Route path="/games/mines" element={<GemMiner />} />
              <Route path="/games/hilo" element={<HiLoRush />} />
              <Route path="/games/plinko" element={<Plinko />} />
              <Route path="/games/tower" element={<Tower />} />
              <Route path="/games/limbo" element={<Limbo />} />
              <Route path="/games/coinflip" element={<CoinFlip />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </PageFade>
          <Footer />
          <GamesBar />
          <BottomNav />
          <ChatWidget />
          <WelcomeBonusModal />
          <Toaster />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
